
import CancelMotive from '@/domain/models/CancelMotive';
import { computed, defineComponent, PropType } from 'vue';
import Button from '../atoms/button.vue';
import Modal from '../atoms/Modal.vue';

export default defineComponent({
  components: { Button, Modal },
  props: {
    motives: {
      type: Array as PropType<Array<CancelMotive>>,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['next', 'cancel', 'update:modelValue'],
  setup(props, { emit }) {
    const selectedMotive = computed({
      get: (): string => props.modelValue,
      set: (motiveId: string) => {
        emit('update:modelValue', motiveId);
      },
    });

    const motiveInputId = (motive: CancelMotive, index: number): string => (
      `motive-${motive.id}-${index}`
    );

    const isSelected = (motiveId: string): boolean => (
      props.modelValue === motiveId
    );

    const hasSelectedMotive = computed(() => props.modelValue !== '');

    return {
      selectedMotive,
      motiveInputId,
      isSelected,
      hasSelectedMotive,
    };
  },
});
